import { render, staticRenderFns } from "./CourseTopHeader.vue?vue&type=template&id=0a4002a0&scoped=true"
import script from "./CourseTopHeader.vue?vue&type=script&lang=js"
export * from "./CourseTopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4002a0",
  null
  
)

export default component.exports